import { of as observableOf, Observable } from 'rxjs'
import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FeeScheduleODataService, IFeeSchedule } from '@exchange/domain/.'
import { UtilService } from '@exchange/services/.'
import { TabsetComponent } from 'ngx-bootstrap/tabs'
import { ToastrService } from 'ngx-toastr'
import { PagedResult } from 'common-services'

@Component({
  selector: 'app-fee-schedule-edit',
  templateUrl: './fee-schedule-edit.component.html',
  standalone: false
})
export class FeeScheduleEditComponent implements OnInit {
  @ViewChild('tabs') tabs: TabsetComponent

  title = 'Edit Fee Schedule'
  model: IFeeSchedule = {} as IFeeSchedule

  busy: any = null
  feeScheduleId: number

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private odata: FeeScheduleODataService,
    public util: UtilService,
    private toastr: ToastrService
  ) {}

  initializeAdd() {
    this.title = 'Add Fee Schedule'
    const provider = {
      Id: 0,
      Name: '',
      ActiveOnDateTime: null,
      ExpiresOnDateTime: null
    } as IFeeSchedule
    const paged = {
      skipped: 0,
      rowCount: 1,
      data: [provider]
    } as PagedResult<IFeeSchedule>

    return observableOf(paged)
  }

  initializeEdit() {
    return this.initializeModel()
  }

  private initializeModel(): Observable<PagedResult<IFeeSchedule>> {
    return this.odata.query().filter(`Id eq ${this.feeScheduleId}`).exec()
  }

  ngOnInit() {
    this.feeScheduleId = +this.route.snapshot.params['id']

    this.route.params.subscribe(params => {
      const fn = this.feeScheduleId ? this.initializeEdit.bind(this) : this.initializeAdd.bind(this)

      fn().subscribe(response => {
        this.model = response.data[0]
      })
    })
  }

  onSubmit(): boolean {
    const errors = []

    if (!this.model.Name) {
      errors.push('Name is required.')
    }

    if (!this.model.ActiveOnDateTime) {
      errors.push('Active On is required.')
    }

    if (!this.model.ExpiresOnDateTime) {
      errors.push('Expires On is required.')
    }

    this.toastr.clear()
    if (errors.length > 0) {
      this.toastr.error(errors.join('<br />'))
      return
    }

    const model = {
      Id: +this.model.Id || undefined,
      Name: this.model.Name,
      ActiveOnDateTime: this.model.ActiveOnDateTime,
      ExpiresOnDateTime: this.model.ExpiresOnDateTime
    }

    const observable = model.Id
      ? this.odata.put(model as IFeeSchedule, model.Id).exec()
      : this.odata.post(model as IFeeSchedule).exec()

    this.busy = observable.subscribe(result => {
      this.busy = null

      if (this.model.Id) {
        // This was an update.
        this.backToList('Fee Schedule was saved successfully.')
      } else {
        // This was a create.
        this.toastr.success('Fee Schedule was saved successfully.')

        this.model.Id = this.feeScheduleId = +result.Id
        this.initializeModel()

        setTimeout(() => {
          this.tabs.tabs[1].active = true
        }, 1)
      }
    }, this.showError.bind(this))
  }

  showError(response): void {
    this.busy = null

    const msg = this.util.getErrorString(response)

    this.toastr.error(msg)
  }

  backToList(successMessage: string = null) {
    this.router.navigate(['/system', 'feeschedules'], {
      queryParams: { successMessage }
    })
  }
}
